export default "__VITE_ASSET__CuliO7k3__"